import store from "../store/index";
//-------------
// get options
//-------------
export default function getOptions() {
  //-----------------
  // get all options
  //-----------------
  const this_store = store;
  const options = this_store.getters["combat/getOptions"];
  return options;
}